import { useState } from "react";
import { FaPhoneAlt, FaEnvelope, FaInstagram } from "react-icons/fa";

function Contact() {

    const [formData, setFormData] = useState({
        name: "",
        email: "",
        message: "",
    });

    const [loading, setLoading] = useState(false);

    const [submitted, setSubmitted] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
        ...formData,
        [name]: value,
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        const data = {
            access_key: "c7c0a70a-fc36-4f67-bd6e-89e3ef21b56a",
            name: formData.name,
            email: formData.email,
            message: formData.message,
        };

        try {
            const response = await fetch("https://api.web3forms.com/submit", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(data),
            });
            const result = await response.json();
            if (result.success) {
                setSubmitted(true);
            } else {
                alert("❌ Erreur lors de l'envoi du message.");
            }
        } catch {
            alert("❌ Erreur réseau, veuillez réessayer.");
        } finally {
            setLoading(false);
        }
    };

    return(
        <div>
            <div className="contact-info">
                <p className="contact-info-title">BazEvent</p>
                
                <div className="contact-line">
                    <FaPhoneAlt className="contact-icon" />
                    <span>07-68-75-09-28</span>
                </div>

                <div className="contact-line">
                    <FaEnvelope className="contact-icon" />
                    <span>bazevent10@gmail.com</span>
                </div>

                <div className="contact-line">
                    <FaInstagram className="contact-icon" />
                    <span>@baz_event</span>
                </div>
            </div>

            <div className="contact-container">
                <h2 className="contact-title">Contactez-nous</h2>
                <p className="contact-subtitle">
                    Remplissez le formulaire ci-dessous, nous reviendrons vers vous rapidement.
                </p>

                {submitted ? (
                    <p className="contact-success">
                    ✅ Merci ! Votre message a bien été envoyé.
                    </p>
                ) : (
                    <form onSubmit={handleSubmit} className="contact-form">
                    {/* Nom */}
                    <div className="contact-group">
                        <label className="contact-label">Nom</label>
                        <input
                        type="text"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        required
                        className="contact-input"
                        />
                    </div>

                    {/* Email */}
                    <div className="contact-group">
                        <label className="contact-label">Email</label>
                        <input
                        type="email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        required
                        className="contact-input"
                        />
                    </div>

                    {/* Message */}
                    <div className="contact-group">
                        <label className="contact-label">Message</label>
                        <textarea
                        name="message"
                        value={formData.message}
                        onChange={handleChange}
                        required
                        rows="5"
                        className="contact-textarea"
                        />
                    </div>

                    {/* Bouton */}
                    <button type="submit" className="contact-button" disabled={loading}>
                        {loading ? "Envoi en cours..." : "✉️ Envoyer"}
                    </button>
                    </form>
                )}
            </div>
        </div>
    )
 }

export default Contact;